/// <reference path="../../../../typings/index.d.ts" />
///<reference path="models/short-cuts-combination.model.ts"/>
///<reference path="short-cuts.interfaces.ts"/>
///<reference path="../common/security.keys.ts"/>
///<reference path="../common/security.parts.ts"/>



module Meevo.Components.ShortCuts {
    //#regionImports
    import SecurityParts = Meevo.Components.Common.SecurityParts;
    import SecurityKeys = Meevo.Components.Common.SecurityKeys;
    //#endregionImports

    //#regionVariableDeclarations
    export const mainKey: string = 'ctrl';
    export const macOsMainKeyDefault: string = 'ctrl';

    export const secondaryKey: string = 'alt';
    export const appointmentBookKeyDefault: string = 'shift';

    //#endregionVariableDeclarations


    //#regionShortKeysListService

    export class ShortCutsListService implements IShortCutsListService {

        private readonly combinations: ICombinationNames; // the list of all combinations

        static factory(): Function {
            let service = () => new ShortCutsListService();

            service.$inject = [];
            return service;
        }

        constructor() {
            this.combinations = <ICombinationNames>{
                //#regionGlobal
                GLOBAL_MENU: new ShortCutCombination('z', {secondaryKey, mainKey, description: 'Meevo Menu'}),
                GLOBAL_FIND: new ShortCutCombination('f', {secondaryKey, mainKey, description: 'Client Find'}),
                GLOBAL_HELP: new ShortCutCombination('h', {secondaryKey, mainKey, description: 'Help'}),
                GLOBAL_LOCKOUT: new ShortCutCombination('o', { secondaryKey, mainKey, description: 'Lock Session' }),
                GLOBAL_LOCATION: new ShortCutCombination('l', { secondaryKey, mainKey, description: 'Location Search' }),
                //#rndregionGlobal

                //#regionDataMaitanance
                DATA_MAINTENANCE_SAVE: new ShortCutCombination('s', {secondaryKey, mainKey, description: 'Save'}),
                DATA_MAINTENANCE_ADD: new ShortCutCombination('n', {secondaryKey, mainKey, description: 'Add New'}),
                DATA_MAINTENANCE_CANCEL: new ShortCutCombination('c', {secondaryKey, mainKey, description: 'Cancel'}),
                DATA_MAINTENANCE_EDIT: new ShortCutCombination('e', {secondaryKey, mainKey, description: 'Edit'}),
                DATA_MAINTENANCE_DELETE: new ShortCutCombination('d', {secondaryKey, mainKey, description: 'Delete'}),
                DATA_MAINTENANCE_COPY: new ShortCutCombination('y', {secondaryKey, mainKey, description: 'Copy'}),
                DATA_MAINTENANCE_UNDELETE: new ShortCutCombination('u', {secondaryKey, mainKey, description: 'Undelete'}),
                DATA_MAINTENANCE_APPLY: new ShortCutCombination('a', { secondaryKey, mainKey, description: 'Apply' }),
                DATA_MAINTENANCE_BACK: new ShortCutCombination('b', { secondaryKey, mainKey, description: 'Back' }),
                //#endregionDataMaitanance

                //#regionRegister
                REGISTER_POP_DRAWER: new ShortCutCombination('d', {secondaryKey, mainKey, description: 'Pop drawer'}),
                REGISTER_PAY_NOW: new ShortCutCombination('p', { secondaryKey, mainKey, description: 'Pay now' }),
                REGISTER_REFUND: new ShortCutCombination('r', {secondaryKey, mainKey, description: 'Refund'}),
                REGISTER_NO_SALE: new ShortCutCombination('n', {secondaryKey, mainKey, description: 'No Sale'}),
                REGISTER_HOLD: new ShortCutCombination('h', {secondaryKey, mainKey, description: 'Hold'}),
                REGISTER_CANCEL: new ShortCutCombination('c', {secondaryKey, mainKey, description: 'Cancel'}),
                REGISTER_BACK_TO_SALE: new ShortCutCombination('b', {secondaryKey, mainKey, description: 'Back to sale'}),
                REGISTER_RETURN_TRANSACTION: new ShortCutCombination('r', { secondaryKey, mainKey, description: 'Return Transaction' }),
                REGISTER_LAST_CLIENT_USED: new ShortCutCombination('alt+l', {description: 'Last Client Used' }),
                //#endregionRegister

                //#regionAppointmentBook
                APPOINTMENT_BOOK_TODAY: new ShortCutCombination('h', { secondaryKey: appointmentBookKeyDefault, mainKey: secondaryKey, description: 'Appointment Book: Today' }),
                APPOINTMENT_BOOK_EDITOR: new ShortCutCombination('e', { secondaryKey: appointmentBookKeyDefault, mainKey: secondaryKey, description: 'Appointment Book: Editor' }),
                APPOINTMENT_BOOK_SAVE: new ShortCutCombination('s', {secondaryKey, mainKey, description: 'Appointment Book: Save'}),
                APPOINTMENT_BOOK_CANCEL: new ShortCutCombination('c', {secondaryKey, mainKey, description: 'Appointment Book: Cancel'}),
                APPOINTMENT_BOOK_DELETE: new ShortCutCombination('d', { secondaryKey, mainKey, description: 'Appointment Book: Delete' }),
                APPOINTMENT_BOOK_CLEAR_FILTERS: new ShortCutCombination('a', { secondaryKey: appointmentBookKeyDefault, mainKey: secondaryKey, description: 'Appointment Book: Clear filters' }),
                APPOINTMENT_BOOK_NUMBER_OF_WEEKS_1: new ShortCutCombination('1', { secondaryKey: appointmentBookKeyDefault, mainKey: 'alt', description: 'Go ahead 1 week' }),
                APPOINTMENT_BOOK_NUMBER_OF_WEEKS_2: new ShortCutCombination('2', { secondaryKey: appointmentBookKeyDefault, mainKey: 'alt', description: 'Go ahead 2 week' }),
                APPOINTMENT_BOOK_NUMBER_OF_WEEKS_3: new ShortCutCombination('3', { secondaryKey: appointmentBookKeyDefault, mainKey: 'alt', description: 'Go ahead 3 week' }),
                APPOINTMENT_BOOK_NUMBER_OF_WEEKS_4: new ShortCutCombination('4', { secondaryKey: appointmentBookKeyDefault, mainKey: 'alt', description: 'Go ahead 4 week' }),
                APPOINTMENT_BOOK_NUMBER_OF_WEEKS_5: new ShortCutCombination('5', { secondaryKey: appointmentBookKeyDefault, mainKey: 'alt', description: 'Go ahead 5 week' }),
                APPOINTMENT_BOOK_NUMBER_OF_WEEKS_6: new ShortCutCombination('6', { secondaryKey: appointmentBookKeyDefault, mainKey: 'alt', description: 'Go ahead 6 week' }),
                APPOINTMENT_BOOK_NUMBER_OF_WEEKS_7: new ShortCutCombination('7', { secondaryKey: appointmentBookKeyDefault, mainKey: 'alt', description: 'Go ahead 7 week' }),
                APPOINTMENT_BOOK_NUMBER_OF_WEEKS_8: new ShortCutCombination('8', { secondaryKey: appointmentBookKeyDefault, mainKey: 'alt', description: 'Go ahead 8 week' }),
                APPOINTMENT_BOOK_NUMBER_OF_WEEKS_9: new ShortCutCombination('9', { secondaryKey: appointmentBookKeyDefault, mainKey: 'alt', description: 'Go ahead 9 week' }),
                APPOINTMENT_BOOK_NUMBER_OF_WEEKS_10: new ShortCutCombination('0', { secondaryKey: appointmentBookKeyDefault, mainKey: 'alt', description: 'Go ahead 10 week' }),
                APPOINTMENT_BOOK_APPLY_CUSTOM_FILTER: new ShortCutCombination('x', { secondaryKey: appointmentBookKeyDefault, mainKey: 'alt', description: 'Apply custom defined employee category filter' }),
                APPOINTMENT_BOOK_PRECISION_TIMING: new ShortCutCombination('p', { secondaryKey: appointmentBookKeyDefault, mainKey: secondaryKey, description: 'Appointment Book: Precising Timing' }),
                //#endregionAppointmentBook

                //#regionAppointmentBookEditor
                APPT_EDITOR_TA_LAST_CLIENT: new ShortCutCombination('alt+l', { description: 'Last Client Used' }),
                APPT_EDITOR_SAVE: new ShortCutCombination('s', { secondaryKey, mainKey, description: 'Save' }),
                APPT_EDITOR_CANCEL: new ShortCutCombination('c', { secondaryKey, mainKey, description: 'Cancel' }),
                APPT_EDITOR_DELETE: new ShortCutCombination('d', { secondaryKey, mainKey, description: 'Delete' }),


                //#endregionAppointmentBookEditor

                //#regionNavMenu
                NAV_MENU_DATA: new ShortCutCombination('d', {securityKey: SecurityKeys.DATA + SecurityParts.KEY_PART_READ}),
                NAV_MENU_DATA_CLIENTS: new ShortCutCombination('c', {securityKey: SecurityKeys.DATA_CLIENT + SecurityParts.KEY_PART_READ}),
                NAV_MENU_DATA_EMPLOYEE: new ShortCutCombination('e', {securityKey: SecurityKeys.DATA_EMPLOYEE + SecurityParts.KEY_PART_READ}),
                NAV_MENU_DATA_PACKAGE: new ShortCutCombination('k', {securityKey: SecurityKeys.DATA_PACKAGETYPE + SecurityParts.KEY_PART_READ}),
                NAV_MENU_DATA_PRODUCT: new ShortCutCombination('p', {securityKey: SecurityKeys.DATA_PRODUCT + SecurityParts.KEY_PART_READ}),
                NAV_MENU_DATA_SERVICE: new ShortCutCombination('s', {securityKey: SecurityKeys.DATA_SERVICE + SecurityParts.KEY_PART_READ}),

                NAV_MENU_SCHEDULES: new ShortCutCombination('s', {securityKey: SecurityKeys.SCHEDULES + SecurityParts.KEY_PART_READ}),
                NAV_MENU_SCHEDULES_SCHEDULES: new ShortCutCombination('s', {securityKey: SecurityKeys.SCHEDULES_CALENDAR + SecurityParts.KEY_PART_READ}),
                NAV_MENU_SCHEDULES_TIME_CLOCK: new ShortCutCombination('t', {securityKey: SecurityKeys.SCHEDULES_TIMECLOCK + SecurityParts.KEY_PART_READ}),
                NAV_MENU_SCHEDULES_WORK_ACTIVITIES: new ShortCutCombination('w', {securityKey: SecurityKeys.DATA_WORKACTIVITY + SecurityParts.KEY_PART_READ}),

                NAV_MENU_APPOINTMENT: new ShortCutCombination('a', {securityKey: SecurityKeys.APPOINTMENTS + SecurityParts.KEY_PART_READ}),
                NAV_MENU_APPOINTMENT_APPOINTMENT_BOOK: new ShortCutCombination('a', {securityKey: SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK + SecurityParts.KEY_PART_READ}),
                NAV_MENU_APPOINTMENT_CONFIRMATION_MANAGER: new ShortCutCombination('c', {securityKey: SecurityKeys.APPOINTMENTS_CONFIRMATIONMANAGER + SecurityParts.KEY_PART_READ}),
                NAV_MENU_APPOINTMENT_STANDING_APPOINTMENTS: new ShortCutCombination('s', {securityKey: SecurityKeys.APPOINTMENTS_STANDINGDEFINITION + SecurityParts.KEY_PART_READ}),
                NAV_MENU_APPOINTMENT_WAIT_LIST: new ShortCutCombination('w', {securityKey: SecurityKeys.APPOINTMENTS_WAITLIST + SecurityParts.KEY_PART_READ}),

                NAV_MENU_REGISTER: new ShortCutCombination('r', {securityKey: SecurityKeys.REGISTER + SecurityParts.KEY_PART_READ}),
                NAV_MENU_REGISTER_REGISTER: new ShortCutCombination('r', {securityKey: SecurityKeys.REGISTER_REGISTER + SecurityParts.KEY_PART_READ}),
                NAV_MENU_REGISTER_DRAWER_HISTORY: new ShortCutCombination('h', {securityKey: SecurityKeys.REGISTER_DRAWERHISTORY + SecurityParts.KEY_PART_READ}),
                NAV_MENU_REGISTER_DRAWER_MANAGER: new ShortCutCombination('d', {securityKey: SecurityKeys.REGISTER_DRAWERMANAGER + SecurityParts.KEY_PART_READ}),
                NAV_MENU_REGISTER_TRANSACTION_EDITOR: new ShortCutCombination('t', { securityKey: SecurityKeys.REGISTER_TRANSACTIONEDITOR + SecurityParts.KEY_PART_READ }),
                NAV_MENU_REGISTER_EMPLOYEE_SERVICE_TIMES_PRICING: new ShortCutCombination('p', { securityKey: SecurityKeys.REGISTER_REGISTER_EMPLOYEESERVICETIMESPRICING + SecurityParts.KEY_PART_READ }),

                NAV_MENU_MANAGEMENT: new ShortCutCombination('g', {securityKey: SecurityKeys.MANAGEMENT + SecurityParts.KEY_PART_READ}),
                NAV_MENU_MANAGEMENT_ACTIVITY_LOG: new ShortCutCombination('a', {securityKey: SecurityKeys.MANAGEMENT_ACTIVITYLOG + SecurityParts.KEY_PART_READ}),
                NAV_MENU_MANAGEMENT_ALERTS_LOG: new ShortCutCombination('l', {securityKey: SecurityKeys.MANAGEMENT_ALERTSLOG + SecurityParts.KEY_PART_READ}),
                NAV_MENU_MANAGEMENT_CLIENT_POINTS_MANAGER: new ShortCutCombination('c', {securityKey: SecurityKeys.MANAGEMENT_CLIENTPOINT + SecurityParts.KEY_PART_READ}),
                NAV_MENU_MANAGEMENT_PAYROLL: new ShortCutCombination('p', {securityKey: SecurityKeys.MANAGEMENT_PAYROLL + SecurityParts.KEY_PART_READ}),
                NAV_MENU_MANAGEMENT_SALES_RANKINGS: new ShortCutCombination('s', { securityKey: SecurityKeys.MANAGEMENT_SALESRANKING + SecurityParts.KEY_PART_READ}),

                NAV_MENU_INVENTORY: new ShortCutCombination('i', {securityKey: SecurityKeys.INVENTORY + SecurityParts.KEY_PART_READ}),
                NAV_MENU_INVENTORY_EMPLOYEE_SUPPLY_USAGE: new ShortCutCombination('e', {securityKey: SecurityKeys.INVENTORY_EMPLOYEESUPPLYUSAGE + SecurityParts.KEY_PART_READ}),
                NAV_MENU_INVENTORY_INVENTORY_COUNT: new ShortCutCombination('c', {securityKey: SecurityKeys.INVENTORY_COUNT + SecurityParts.KEY_PART_READ}),
                NAV_MENU_INVENTORY_INVENTORY_RETURNS: new ShortCutCombination('r', {securityKey: SecurityKeys.INVENTORY_RETURNS + SecurityParts.KEY_PART_READ}),
                NAV_MENU_INVENTORY_PURCHASE_ORDERS: new ShortCutCombination('p', {securityKey: SecurityKeys.INVENTORY_PURCHASEORDER + SecurityParts.KEY_PART_READ}),
                NAV_MENU_INVENTORY_STOCK_LEVELS: new ShortCutCombination('s', {securityKey: SecurityKeys.INVENTORY_STOCKLEVEL + SecurityParts.KEY_PART_READ}),

                NAV_MENU_MEMBERSHIP: new ShortCutCombination('m', {securityKey: SecurityKeys.MEMBERSHIP + SecurityParts.KEY_PART_READ}),
                NAV_MENU_MEMBERSHIP_EFT_CONTROL_PANEL: new ShortCutCombination('e', {securityKey: SecurityKeys.MEMBERSHIP_EFTCONTROLPANEL + SecurityParts.KEY_PART_READ}),
                NAV_MENU_MEMBERSHIP_MEMBERSHIP_MANAGER: new ShortCutCombination('m', {securityKey: SecurityKeys.MEMBERSHIP_MEMBERSHIPMANAGER + SecurityParts.KEY_PART_READ}),

                NAV_MENU_BUSINFO: new ShortCutCombination('b', {securityKey: SecurityKeys.BUSINESSINFO + SecurityParts.KEY_PART_READ}),
                NAV_MENU_BUSINFO_BUSINFO: new ShortCutCombination('b', {securityKey: SecurityKeys.DATA_BUSINESSINFO + SecurityParts.KEY_PART_READ}),
                NAV_MENU_BUSINFO_EVENTS: new ShortCutCombination('e', {securityKey: SecurityKeys.BUSINESSINFO_EVENTSCHEDULE + SecurityParts.KEY_PART_READ}),

                NAV_MENU_SMART_CENTER: new ShortCutCombination('c', { securityKey: SecurityKeys.SMARTCENTER + SecurityParts.KEY_PART_READ }),
                NAV_MENU_SMART_CENTER_SMART_CENTER: new ShortCutCombination('s', { securityKey: SecurityKeys.SMARTCENTER_SMARTCENTER + SecurityParts.KEY_PART_READ }),

                NAV_MENU_HELP: new ShortCutCombination('h', {securityKey: SecurityKeys.HELP + SecurityParts.KEY_PART_READ}),
                //#endregionNavMenu

                //#regionTypeAhead
                TA_LAST_CLIENT: new ShortCutCombination('alt+l', {description: 'Last Client', allowIn: ['INPUT']}),
                //#endregionTypeAhead

                //#regionHotkeyCombo
                HOTKEY_COMBO_CLIENTS: new ShortCutCombination('ctrl+alt+z,d,c', { description: 'Clients' }),
                HOTKEY_COMBO_EMPLOYEES: new ShortCutCombination('ctrl+alt+z,d,e', { description: 'Employees' }),
                HOTKEY_COMBO_PACKAGES: new ShortCutCombination('ctrl+alt+z,d,k', { description: 'Packages' }),
                HOTKEY_COMBO_PRODUCTS: new ShortCutCombination('ctrl+alt+z,d,p', { description: 'Products' }),
                HOTKEY_COMBO_SERVICE: new ShortCutCombination('ctrl+alt+z,d,s', { description: 'Services' }),
                HOTKEY_COMBO_SCHEDULES: new ShortCutCombination('ctrl+alt+z,s,s', { description: 'Schedules' }),
                HOTKEY_COMBO_TIME_CLOCK: new ShortCutCombination('ctrl+alt+z,s,t', { description: 'Time Clock' }),
                HOTKEY_COMBO_WORK_ACTIVITIES: new ShortCutCombination('ctrl+alt+z,s,w', { description: 'Work Activities' }),
                HOTKEY_COMBO_APPOINTMENT_BOOK: new ShortCutCombination('ctrl+alt+z,a,a', { description: 'Appointment Book' }),
                HOTKEY_COMBO_CONFIRMATION_MANAGER: new ShortCutCombination('ctrl+alt+z,a,c', { description: 'Confirmation Manager' }),
                HOTKEY_COMBO_STANDING_APPOINTMENTS: new ShortCutCombination('ctrl+alt+z,a,s', { description: 'Standing Appointments' }),
                HOTKEY_COMBO_WAITLIST: new ShortCutCombination('ctrl+alt+z,a,w', { description: 'Wait List' }),
                HOTKEY_COMBO_REGISTER: new ShortCutCombination('ctrl+alt+z,r,r', { description: 'Register' }),
                HOTKEY_COMBO_DRAWER_MANAGER: new ShortCutCombination('ctrl+alt+z,r,d', { description: 'Drawer Manager' }),
                HOTKEY_COMBO_DRAWER_HISTORY: new ShortCutCombination('ctrl+alt+z,r,h', { description: 'Drawer History' }),
                HOTKEY_COMBO_TRANSACTION_EDITOR: new ShortCutCombination('ctrl+alt+z,r,t', { description: 'Transaction Editor' }),
                HOTKEY_COMBO_ACTIVITY_LOG: new ShortCutCombination('ctrl+alt+z,g,a', { description: 'Activity Log' }),
                HOTKEY_COMBO_ALERTS_LOG: new ShortCutCombination('ctrl+alt+z,g,l', { description: 'Alerts Log' }),
                HOTKEY_COMBO_CLIENT_POINTS_MANAGER: new ShortCutCombination('ctrl+alt+z,g,c', { description: 'Client Points Manager' }),
                HOTKEY_COMBO_PAYROLL: new ShortCutCombination('ctrl+alt+z,g,p', { description: 'Payroll' }),
                HOTKEY_COMBO_SALES: new ShortCutCombination('ctrl+alt+z,g,s', { description: 'Sales Rankings & Export' }),
                HOTKEY_COMBO_EMPLOYEE_SUPPLY_USAGE: new ShortCutCombination('ctrl+alt+z,i,e', { description: 'Employee Supply Usage' }),
                HOTKEY_COMBO_INVENTORY_COUNT: new ShortCutCombination('ctrl+alt+z,i,c', { description: 'Inventory Count' }),
                HOTKEY_COMBO_INVENTORY_RETURNS: new ShortCutCombination('ctrl+alt+z,i,r', { description: 'Inventory Returns' }),
                HOTKEY_COMBO_PURCHASE_ORDERS: new ShortCutCombination('ctrl+alt+z,i,p', { description: 'Purchase Orders' }),
                HOTKEY_COMBO_STOCK_LEVELS: new ShortCutCombination('ctrl+alt+z,i,s', { description: 'Stock Levels' }),
                HOTKEY_COMBO_EFT_CONTROL_PANEL: new ShortCutCombination('ctrl+alt+z,m,e', { description: 'EFT Control Panel' }),
                HOTKEY_COMBO_MEMBERSHIP_MANAGER: new ShortCutCombination('ctrl+alt+z,m,m', { description: 'Membership Manager' }),
                HOTKEY_COMBO_BUSINESS_INFORMATION: new ShortCutCombination('ctrl+alt+z,b,b', { description: 'Business Information' }),
                HOTKEY_COMBO_EVENTS: new ShortCutCombination('ctrl+alt+z,b,e', { description: 'Events' }),
                HOTKEY_COMBO_EMPLOYEE_SERVICE_TIMES_PRICING: new ShortCutCombination('ctrl+alt+z,r,p', { description: 'SHORTCUT_LABEL_EMPLOYEESERVICETIMESPRICING' }),


                //#endregionHotkeyCombo

                //#region modals
                MODAL_OK_BUTTON: new ShortCutCombination('k', {description: 'Ok', allowIn: []}),
                MODAL_APPLY_BUTTON: new ShortCutCombination('a', {description: 'Apply', allowIn: []}),
                MODAL_CANCEL_BUTTON: new ShortCutCombination('c', {description: 'Cancel', allowIn: []}),
                MODAL_YES_BUTTON: new ShortCutCombination('y', {description: 'Yes', allowIn: []}),
                MODAL_NO_BUTTON: new ShortCutCombination('n', {description: 'No', allowIn: []}),
                MODAL_SAVE_BUTTON: new ShortCutCombination('s', {description: 'Save', allowIn: []}),
                MODAL_DISMISS: new ShortCutCombination('enter', {description: 'Dismiss Modal', allowIn: []}),
                //#endregion region
            }
        }

        /**
         * @param keys
         * @returns the ShortKeyCombination instance or object of instances
         */
        get(keys: keyof ICombinationNames): IShortCutCombination;
        get<T extends keyof ICombinationNames>(keys: T[]): { [key in T]: IShortCutCombination };
        get<T extends keyof ICombinationNames>(keys: T[] | keyof ICombinationNames): { [key in T]: IShortCutCombination } | IShortCutCombination {

            if (!(keys instanceof Array)) {
                return this.combinations[keys as keyof ICombinationNames] as IShortCutCombination;
            }

            return keys.reduce((res, row: T) => {
                res[row] = this.combinations[row as keyof ICombinationNames];

                return res;
            }, <{ [key in T]: IShortCutCombination }>{})
        }

        getByType(subType: string): any {
            let that = this;
            var keyList = Object.keys(that.combinations);
            var currentSubTypes = [];
            _.each(keyList, function (combo: string, index) {
                //hotkey type must be in the beginning of the string
                if (combo.indexOf(subType) == 0) {
                    currentSubTypes.push(that.combinations[combo]);
                }
                //if (test.includes(subType)) {
                //    console.log("added string");
                //}
            });
            return currentSubTypes;
        }

        /**
         * Method updates the combination list with new hotkeys.
         * @example
         * shortKeysListService.update('DATA_MAINTENANCE_ADD', 'ctrl+alt+delete');
         * @example
         * shortKeysListService.update([{
         *      key     : 'DATA_MAINTENANCE_ADD',
         *      hotKey  : 'ctrl+alt+delete'
         *  },{
         *      key     : 'DATA_MAINTENANCE_CANCEL',
         *      hotKey  : 'ctrl+alt+t'
         *  }]);
         * @param combinationName
         * @param hotKey
         */
        update(combinationName: keyof ICombinationNames, hotKey: string): void;
        update(combinationName: keyof ICombinationNames, hotKey: IShortCutCombination): void;
        update(combinations: { key: keyof ICombinationNames; hotKey: string; }[]): void;
        update(combinations: { key: keyof ICombinationNames; hotKey: IShortCutCombination; }[]): void;
        update(combinationName: keyof ICombinationNames | IShortCutsListUpdateItem[], hotKey?: string | IShortCutCombination): void {
            if (!(combinationName instanceof Array)) {
                combinationName = [{key: combinationName, hotKey: hotKey}];
            }

            combinationName.forEach(row => {
                if (row.hotKey instanceof ShortCutCombination) {
                    this.combinations[row.key] = row.hotKey;
                } else if (!this.combinations[row.key] && typeof row.hotKey === 'string') {
                    this.combinations[row.key] = new ShortCutCombination(row.hotKey);
                } else {
                    this.combinations[row.key].update(row.hotKey as string);
                }
            });
        }

        /**
         * @param keys
         * @returns {string[]} array of hotkeys combinations for given combination keys
         */
        getHotKeys<T extends keyof ICombinationNames>(keys: T[]): string[] {
            const res = this.get(keys);

            return Object
                .keys(res)
                .map((row: T) => this.combinations[row as keyof ICombinationNames].combination)
        }
    }

    //#endregionShortKeysListService

    angular.module('meevo.components.short-cuts')
        .factory('meevo.components.short-cuts.ShortCutsListService', ShortCutsListService.factory());
}
